module.exports = __webpack_public_path__ + "static/media/sss-auto-thumbs.8388e474.svg";